import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import PhoneMask from '../componets/PhoneMask';
import './LinkFailurePage.css';
import { ReactComponent as Logo } from '../res/image/logo.svg'
import { Trans, useTranslation } from 'react-i18next'

declare var document: any;
declare var window: any;

interface ComponentProps {
    setGlobalToken: Function
}

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#000000bf",
        boxShadow: theme.shadows[1],
        fontSize: 16,
    },
}))(Tooltip);

const LinkFailurePage: React.FC<ComponentProps> = (props) => {
    const { setGlobalToken } = props
    const { t } = useTranslation()

    const PageBg: React.FC = () => (
        <>
            <div className="page-bg-1"></div>
            <div className="page-bg-2"></div>
            <div className="page-bg-3"></div>
        </>
    )

    return (
        <div className="chatter-channel-page">
            <PageBg />
            <PhoneMask />

            <section className="appinfo">
                <div className="appinfo-header">
                    <Logo />
                </div>
                <div className="appinfo-title">{t('link.invite.failed')}</div>
                <p className="desc">{t('concat.org.invite.again')}</p>
            </section>

            <div className="content-btn-wrap2">
                <Button className="download-btn" variant="outlined" color="primary" href={`https://account.felo.me/signin/#/`} target="_blank">
                    {t('app.login')}
                </Button>

                <Button className="download-btn" variant="outlined" color="primary" href={`https://account.felo.me/signin?register=ture`} target="_blank">
                    {t('app.register')}
                </Button>
            </div>
        </div>
    )
}

const stateProps = (state: any) => {
    return {
        jwtToken: state.jwtToken
    }
}

const dispatchProps = (dispatch: any) => ({
    setGlobalToken: (token: string) => {
        dispatch({
            type: 'setToken',
            value: token
        })
    },
})

export default connect(stateProps, dispatchProps)(LinkFailurePage)